// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1N-Bt","left":"styles_left__1LkuU","desktopActions":"styles_desktopActions__uXbg0","title":"styles_title__2zzq7"};